import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { EAutomationType, IAutomation } from '../../types';

export enum EAutomationCategory {
  All = 'all',
  Applied = 'applied',
  Test = 'test',
  Interview = 'interview',
}

export enum EAutomationGroup {
  SendEmail = 'Send email',
  Move = 'Move candidates',
  InviteToTest = 'Invite to test',
  MoveBasedOnScore = 'Move candidates based on score',
  RejectBasedOnScore = 'Reject candidates based on score',
}

export type TAutomationSettings = {
  type: EAutomationType;
  group: EAutomationGroup;
  category: EAutomationCategory;
  icon: IconDefinition;
  label: string;
  settings: React.ReactNode;
  confirmation: React.ReactNode;
  requiredFields: {
    destinationStageId?: boolean;
    templateId?: boolean;
    value?: boolean;
  };
};

export type TAutomationWizard = Omit<IAutomation, 'id' | 'createdAt'> &
  Partial<Pick<IAutomation, 'id' | 'createdAt'>>;
